import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import type { LucideIcon } from 'lucide-react-native';
import { View } from 'react-native';

export function UnavailableState({
  eyebrow = 'Unavailable',
  icon,
  title,
  body,
  detail,
  primaryActionLabel,
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
}: {
  eyebrow?: string;
  icon: LucideIcon;
  title: string;
  body: string;
  detail?: string;
  primaryActionLabel: string;
  onPrimaryAction: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
}) {
  return (
    <View className="flex-1 px-5 pb-8 pt-4">
      <View className="flex-1 justify-center">
        <View className="w-full max-w-xl self-center overflow-hidden rounded-3xl border border-primary-edge/35 bg-primary-soft p-6">
          <View className="gap-5">
            <View className="size-14 items-center justify-center rounded-full bg-primary">
              <Icon as={icon} size={28} className="text-primary-foreground" />
            </View>

            <View className="gap-2">
              <Text variant="small" className="uppercase tracking-[2px] text-primary">
                {eyebrow}
              </Text>
              <Text className="text-4xl font-extrabold tracking-tight text-foreground">{title}</Text>
              <Text className="text-base leading-7 text-foreground/85">{body}</Text>
            </View>

            {detail ? (
              <View className="rounded-3xl border border-border/70 bg-card/80 p-4">
                <Text variant="small" className="uppercase tracking-[1.6px] text-muted-foreground">
                  Details
                </Text>
                <Text variant="small" className="mt-2 leading-6 text-muted-foreground">
                  {detail}
                </Text>
              </View>
            ) : null}

            <View className="gap-3">
              <Button size="lg" className="items-center justify-center" onPress={onPrimaryAction}>
                <Text className="font-semibold">{primaryActionLabel}</Text>
              </Button>

              {secondaryActionLabel && onSecondaryAction ? (
                <Button
                  variant="outline"
                  size="lg"
                  className="items-center justify-center border-primary-edge/35 bg-card/70"
                  onPress={onSecondaryAction}>
                  <Text className="font-semibold text-foreground">{secondaryActionLabel}</Text>
                </Button>
              ) : null}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
